export class TrialRegistration {

  public acceptsTerms: boolean;
  public organizationName: string;
  public industry: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
  public street1: string;
  public street2: string;
  public city: string;
  public stateCode: string;
  public postalCode: string;
  public countryCode: string;
  public username: string;
  public loginPrefix: string;
  public password: string;
  public confirmPassword: string;
  public iPadPin: string;
  public iPadPinConfirm: string;
  public selectedPlan: string;

  constructor() {

  }
}
